/**
 * <preorder-fields> keeps a product form in sync with the selected variant: it shows
 * the shipping disclosure and enables the line item property that marks the purchase
 * as a pre-order. Rendered by snippets/preorder-fields.liquid.
 *
 * It deliberately does not touch the add-to-cart label. The FoxKit app owns that,
 * via its own Pre-order campaign, and two scripts writing the same label is a race.
 * FoxKit's Condition must be set to "Quantity is out of stock" so its trigger matches
 * the one in snippets/preorder-check.liquid; otherwise the button and the property
 * can disagree about whether an item is a pre-order.
 */
if (!customElements.get("preorder-fields")) {
  customElements.define(
    "preorder-fields",
    class PreorderFields extends HTMLElement {
      connectedCallback() {
        this.form = this.closest("form");
        if (!this.form) return;

        this.property = this.querySelector("[data-preorder-property]");
        this.note = this.querySelector("[data-preorder-note]");
        this.productId = this.dataset.productId;
        this.preorderIds = this.getPreorderIds();

        this.onDocumentChange = this.onDocumentChange.bind(this);
        this.onVariantChanged = this.onVariantChanged.bind(this);

        document.addEventListener("change", this.onDocumentChange);
        document.addEventListener("variant:changed", this.onVariantChanged);

        if (window.MinimogEvents && this.productId) {
          this.unsubscribe = window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, () => this.update());
        }

        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener("change", this.onDocumentChange);
        document.removeEventListener("variant:changed", this.onVariantChanged);
        if (this.unsubscribe) this.unsubscribe();
      }

      getPreorderIds() {
        const data = this.querySelector("[data-preorder-variants]");
        if (!data) return [];
        try {
          return (JSON.parse(data.textContent) || []).map(Number);
        } catch (e) {
          return [];
        }
      }

      onDocumentChange(event) {
        if (!this.form.contains(event.target)) return;
        // Let the theme's own change handlers finish before reading the variant id.
        requestAnimationFrame(() => this.update());
      }

      onVariantChanged() {
        requestAnimationFrame(() => this.update());
      }

      getSelectedVariantId() {
        const input = this.form.querySelector('[name="id"]');
        return input && input.value ? Number(input.value) : null;
      }

      isPreorder() {
        const id = this.getSelectedVariantId();
        return !!id && this.preorderIds.indexOf(id) !== -1;
      }

      update() {
        const preorder = this.isPreorder();

        if (this.property) this.property.disabled = !preorder;
        if (this.note) this.note.hidden = !preorder;
      }
    }
  );
}
